import profilePlaceholder from '../assets/profile-placeholder.svg';

export const PROFILE_PLACEHOLDER = profilePlaceholder;